export default "/images/claritask-hover-light.svg?dd4626e2c2db622ae2b882d92ec7cb8e";